import { format } from 'date-fns';

export const NumberFormat = (cellInfo: any) => {
  const { value } = cellInfo.cell;

  const numberWithCommas = (x: string) => {
    return ((x && x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")) || '');
  };

  const fixedDecimal = (x: any) => {
    let INTVAL = Number(x);
    let val = (INTVAL && INTVAL.toFixed(2)) || '';
    return (val && numberWithCommas(val)) || val;
  };

  return fixedDecimal(value);
};

export const NumberFormater = (value: any) => {
  const numberWithCommas = (x: string | number) => {
    return ((x && x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")) || '');
  };
  

  const fixedDecimal = (x: any) => {
    let INTVAL = Number(x);
    let val = (INTVAL && INTVAL.toFixed(2)) || INTVAL;
    return (val && numberWithCommas(val)) || val;
  };

  return fixedDecimal(value);
};

export const NumberFormaterNew = (value: any) => {
  const numberWithCommas = (x: string | number) => {
    return ((x && x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")) || '');
  };
  

  const fixedDecimal = (x: any) => {
    let INTVAL = Number(x);
    let val = (INTVAL && INTVAL.toFixed(4)) || INTVAL;
    return (val && numberWithCommas(val)) || val;
  };

  return fixedDecimal(value);
};


export const RoundedDecimal = (value: any) => {
  const numberWithCommas = (x: string | number) => {
    return (
      (x && x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")) || ''
    );
  };

  const fixedDecimal = (x: any) => {
    let INTVAL = Number(x);
    let val = (INTVAL && INTVAL.toFixed(1)) || INTVAL; //
    return (val && numberWithCommas(val)) || val;
  };

  return fixedDecimal(value);
};

export const DateFormater = (value: string, dateFormat: any) => {
  const dateSplit = value.split('-');
  const newDate = new Date(
    dateSplit[1] + '-' + dateSplit[0] + '-' + dateSplit[2]
  );
  return format(newDate, dateFormat);
};